import { useState, useRef, useEffect } from 'react';
import OPPop from '../components/OPPop';
import video_6 from '../assets/videos/6.mp4';
import img_1 from '../assets/images/rhy/1.webp';
import img_2 from '../assets/images/rhy/2.webp';
import img_3 from '../assets/images/rhy/3.webp';
import img_4 from '../assets/images/exp/2.webp';
import img_4_5 from '../assets/images/rhy/4-5.webp';
import img_4_6 from '../assets/images/rhy/4-6.webp';
import img_4_7 from '../assets/images/rhy/4-7.webp';
import img_4_8 from '../assets/images/rhy/4-8.webp';
import img_4_9 from '../assets/images/rhy/4-9.webp';
import img_4_10 from '../assets/images/rhy/4-10.webp';
import img_4_11 from '../assets/images/rhy/4-11.webp';
import img_4_13 from '../assets/images/rhy/4-13.webp';
import img_4_14 from '../assets/images/rhy/4-14.webp';
import img_4_15 from '../assets/images/rhy/4-15.webp';
import img_4_16 from '../assets/images/rhy/4-16.webp';
import img_4_17 from '../assets/images/rhy/4-17.webp';
import img_4_18 from '../assets/images/rhy/4-18.webp';
import img_4_19 from '../assets/images/rhy/4-19.webp';


import ana_1 from '../assets/images/ana/1.webp';
import ana_2 from '../assets/images/ana/2.webp';
import ana_3 from '../assets/images/ana/3.webp';
import ana_4 from '../assets/images/ana/4.webp';
import ana_5 from '../assets/images/ana/5.webp';
import ana_6 from '../assets/images/ana/6.webp';
import ana_7 from '../assets/images/ana/7.webp';
import ana_8 from '../assets/images/ana/8.webp';
import ana_9 from '../assets/images/ana/9.webp';
import ana_10 from '../assets/images/ana/10.webp';
import ana_11 from '../assets/images/ana/11.webp';
import ana_12 from '../assets/images/ana/12.webp';
import ana_13 from '../assets/images/ana/13.webp';
import ana_14 from '../assets/images/ana/14.webp';
import ana_15 from '../assets/images/ana/15.webp';
import ana_16 from '../assets/images/ana/16.webp';
import ana_17 from '../assets/images/ana/17.webp';
import ana_18 from '../assets/images/ana/18.webp';

import h_1 from '../assets/images/high/1.webp';
import h_2 from '../assets/images/high/2.webp';
import h_3 from '../assets/images/high/3.webp';
import h_4 from '../assets/images/high/4.webp';
import h_5 from '../assets/images/high/5.webp';
import h_6 from '../assets/images/high/6.webp';
import h_7 from '../assets/images/high/7.webp';
import h_8 from '../assets/images/high/8.webp';
import h_9 from '../assets/images/high/9.webp';
import h_10 from '../assets/images/high/10.webp';
import h_11 from '../assets/images/high/11.webp';
import h_12 from '../assets/images/high/12.webp';
import h_13 from '../assets/images/high/13.webp';
import h_14 from '../assets/images/high/14.webp';
import h_15 from '../assets/images/high/15.webp';
import h_16 from '../assets/images/high/16.webp';
import h_17 from '../assets/images/high/17.webp';
import h_18 from '../assets/images/high/18.webp';
import h_19 from '../assets/images/high/19.webp';
import h_20 from '../assets/images/high/20.webp';
import h_21 from '../assets/images/high/21.webp';
import h_22 from '../assets/images/high/22.webp';
import h_23 from '../assets/images/high/23.webp';
import h_24 from '../assets/images/high/24.webp';
import h_25 from '../assets/images/high/25.webp';
import h_26 from '../assets/images/high/26.webp';
import h_27 from '../assets/images/high/27.webp';
import h_28 from '../assets/images/high/28.webp';
import h_29 from '../assets/images/high/29.webp';

// 瓷品项接口
interface PorcelainItem {
  id: number;
}

export default function RhymeTasting() {
  // 新增：状态记录父节点是否可见
  const [isParentInView, setIsParentInView] = useState(false);
  // 新增：父容器ref（假设图片的父容器是某个div，需根据实际结构调整）
  const parentRef = useRef<HTMLDivElement>(null);
  // 新增：状态记录父节点是否可见
  const [isParentInView1, setIsParentInView1] = useState(false);
  // 新增：父容器ref（假设图片的父容器是某个div，需根据实际结构调整）
  const parentRef1 = useRef<HTMLDivElement>(null);
  // 新增：状态记录父节点是否可见
  const [isParentInView2, setIsParentInView2] = useState(false);
  // 新增：父容器ref（假设图片的父容器是某个div，需根据实际结构调整）
  const parentRef2 = useRef<HTMLDivElement>(null);
  const [isParentInView3, setIsParentInView3] = useState(false);
  // 新增：父容器ref（假设图片的父容器是某个div，需根据实际结构调整）
  const parentRef3 = useRef<HTMLDivElement>(null);

  const [isLeftActive, setIsLeftActive] = useState(false);
  const [selectedItem, setSelectedItem] = useState<PorcelainItem | null>(null);

  const handleSetTenActive = () => {
    if (isLeftActive) {
      setIsLeftActive(false);
    } else {
      setIsLeftActive(true);
    }
  };

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      const [entry] = entries;
      if (entry.isIntersecting) {
        setIsParentInView(true); // 父节点进入视口时触发
        observer.unobserve(entry.target); // 触发后停止监听
      }
    }, {
      rootMargin: '-50px 0px', // 调整触发时机（可选）
    });

    if (parentRef.current) {
      observer.observe(parentRef.current); // 监听父容器
    }

    return () => {
      if (parentRef.current) observer.unobserve(parentRef.current);
    };
  }, []);
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      const [entry] = entries;
      if (entry.isIntersecting) {
        setIsParentInView1(true); // 父节点进入视口时触发
        observer.unobserve(entry.target); // 触发后停止监听
      }
    }, {
      rootMargin: '-50px 0px', // 调整触发时机（可选）
    });

    if (parentRef1.current) {
      observer.observe(parentRef1.current); // 监听父容器
    }

    return () => {
      if (parentRef1.current) observer.unobserve(parentRef1.current);
    };
  }, []);
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      const [entry] = entries;
      if (entry.isIntersecting) {
        setIsParentInView2(true); // 父节点进入视口时触发
        observer.unobserve(entry.target); // 触发后停止监听
      }
    }, {
      rootMargin: '-50px 0px', // 调整触发时机（可选）
    });

    if (parentRef2.current) {
      observer.observe(parentRef2.current); // 监听父容器
    }

    return () => {
      if (parentRef2.current) observer.unobserve(parentRef2.current);
    };
  }, []);
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      const [entry] = entries;
      if (entry.isIntersecting) {
        setIsParentInView3(true); // 父节点进入视口时触发
        observer.unobserve(entry.target); // 触发后停止监听
      }
    }, {
      rootMargin: '-50px 0px', // 调整触发时机（可选）
    });

    if (parentRef3.current) {
      observer.observe(parentRef3.current); // 监听父容器
    }

    return () => {
      if (parentRef3.current) observer.unobserve(parentRef3.current);
    };
  }, []);
  return (
    <div className="relative" style={{ overflowX: 'hidden' }}>
      {/* 第一部分 */}
      <div className="relative">
        <img src={img_1} alt="Hero background" className="w-full h-auto" />
        <div className="left-[6vw]  bottom-[5vw] absolute w-[38%]">
          <div className="flex flex-col items-left">
            <span className="text-[#ffffffc6] text-[0.8vw] leading-[1.5vw] text-justify">品韵篇，通过对项元汴个人评价和审美偏好图谱的可视化分析，解码项元汴的个人鉴藏审美偏好，并试图探索项元汴个人主观鉴藏偏好与瓷器独特性量化客观数据之间的深层关联。</span>
            <span className="text-[#ffffffc6] text-[0.8vw] leading-[1.5vw] text-justify">Chapter on Aesthetic Appreciation: Through visual analysis of Xiang Yuanbian’s personal evaluations and aesthetic preference profiles, this study decodes his individual tastes in connoisseurship and collecting. It further seeks to explore the deeper connections between Xiang Yuanbian’s subjective preferences in ceramic appreciation and the quantifiable objective characteristics of the porcelains themselves.</span>
          </div>
        </div>
      </div>
      {/* 第二部分 */}
      <div className="relative">
        <img src={img_2} alt="Hero background" className="w-full h-auto" />
        <div className="left-[25%] top-[4%] absolute w-[50%]">
          <div className="flex flex-col items-left">
            <span className="text-[#ffffff] text-[2vw] text-center">项元汴评语审美偏好分析</span>
            <span className="text-[#ffffff] text-[1.5vw]  text-center">Analysis of the Aesthetic Preferences of Xiang Yuanbian's Commentaries</span>
          </div>
        </div>
        <div className="left-[15%]  top-[10%] absolute w-[70%]">
          <div className="flex flex-col items-left">
            <span className="text-[#ffffff] text-[0.8vw] text-center leading-[1.5vw]">欢迎踏入鉴藏家的精神宇宙。这里，项元汴42,187字的亲笔评注不再是尘封的墨迹，而是解码明代审美基因的密钥。如果说“探微”篇揭示了瓷器的客观基因，那么“品韵”篇则将镜头对准项元汴的主观审美宇宙。作为明代最具影响力的鉴藏家，他以“精鉴藏，通画理”的哲学，将艺术鉴赏升华为文化修行。您可以点击每个瓷器的项元汴评价图谱放大查看。</span>
            <span className="text-[#ffffff] text-[0.8vw] text-center mt-[1.5vw] leading-[1.5vw]">Welcome to the Spiritual Universe of the Connoisseur.</span>
            <span className="text-[#ffffff] text-[0.8vw] text-center leading-[1.5vw]">Here, Xiang Yuanbian’s 42,187 characters of handwritten commentary—once thought to be nothing more than ink sealed by time—now serve as the key to decoding the aesthetic DNA of the Ming dynasty. If the "Tracing the Subtle" chapter reveals the objective artistic and material genes of porcelain, then the "Appreciating Elegance" chapter turns the lens inward, into Xiang Yuanbian’s subjective world of aesthetic perception. As the most influential collector of the Ming period, he elevated art appreciation into a cultural practice through his philosophy of "precise connoisseurship and deep understanding of painting principles."</span>
            <span className="text-[#ffffff] text-[0.8vw] text-center leading-[1.5vw]">You may click on each porcelain item to view and zoom in on Xiang Yuanbian’s evaluation charts.</span>
          </div>
        </div>
        <div className="left-0 top-[25%] absolute w-full h-[77%]">

          <img src={ana_4} className="top-[2%] left-0 w-[17%] h-auto absolute analysis-body" />
          <img src={ana_1} className="top-[0%] left-[18%] w-[20%] h-auto absolute analysis-body" />
          <img src={ana_2} className="top-[-3%] left-[40%] w-[23%] h-auto absolute analysis-body" />
          <img src={ana_6} className="top-[-3%] left-[61%] w-[27%] h-auto absolute analysis-body" />
          <img src={ana_3} className="top-[-3%] right-0 w-[14.5%] h-auto absolute analysis-body" />

          <img src={ana_5} className="top-[20%] left-0 w-[26%] h-auto absolute analysis-body" />
          <img src={ana_7} className="top-[22%] left-[25.5%] w-[22%] h-auto absolute analysis-body" />
          <img src={ana_8} className="top-[21%] left-[48.5%] w-[29%] h-auto absolute analysis-body" />
          <img src={ana_10} className="top-[22%] right-0 w-[19.5%] h-auto absolute analysis-body" />

          <img src={ana_9} className="top-[42%] left-0 w-[17%] h-auto absolute analysis-body" />
          <img src={ana_11} className="top-[39.5%] left-[20%] w-[30%] h-auto absolute analysis-body" />
          <img src={ana_12} className="top-[40%] left-[47%] w-[30%] h-auto absolute analysis-body" />
          <img src={ana_13} className="top-[44%] right-0 w-[21.5%] h-auto absolute analysis-body" />

          <img src={ana_14} className="top-[64.5%] left-0 w-[16.5%] h-auto absolute analysis-body" />
          <img src={ana_15} className="top-[63%] left-[17%] w-[25%] h-auto absolute analysis-body" />
          <img src={ana_16} className="top-[63%] left-[38%] w-[25%] h-auto absolute analysis-body" />
          <img src={ana_18} className="top-[58%] left-[64%] w-[30%] h-auto absolute analysis-body" />
          <img src={ana_17} className="top-[62%] right-0 w-[16%] h-auto absolute analysis-body" />
        </div>
      </div>
      {/* 第三部分 */}
      <div className="relative">
        <img src={img_3} alt="Hero background" className="w-full h-auto" />
        <div className="left-[32%] top-[4%] absolute w-[35%]">
          <div className="flex flex-col items-left">
            <span className="text-[#ffffff] text-[1.8vw] text-center">项元汴评语词云图</span>
            <span className="text-[#ffffff] text-[1.2vw]  text-center">Xiang Yuanbian's Commentary Word Cloud</span>
          </div>
        </div>
        <div className="right-[5%] top-[20%] absolute w-[26%]">
          <div className="flex flex-col items-left">
            <span className="text-[#ffffff] text-[0.8vw] text-right leading-[1.5vw]">本篇通过自然语言处理（NLP）技术，对《图谱》中83件瓷器的评语进行情感分析与关键词提取，词云图中高频浮现的“奇”“典范”“佳”，不仅是审美密码，更是文人精神的映射。</span>
            <span className="text-[#ffffff] text-[0.8vw] mt-[1vw] text-right leading-[1.5vw]">
              This section employs Natural Language Processing (NLP) techniques to conduct sentiment analysis and keyword extraction on the 83 porcelain entries in the Illustrated Catalogue. The frequent appearance of terms such as "qi" (extraordinary), "fandian" (paragon), and "jia" (excellent) in the word cloud not only deciphers aesthetic values, but also reflects the intellectual spirit of the literati class.</span>
          </div>
        </div>
        <div className="left-[6%] top-[14%] absolute w-[80%] h-[85%]">
          <iframe
            src='https://flo.uri.sh/visualisation/23738613/embed'
            title='Interactive or visual content'
            className='flourish-embed-iframe'
            style={{ width: '100%', height: '100%' }}
            sandbox='allow-same-origin allow-forms allow-scripts allow-downloads allow-popups allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation'>
          </iframe>
        </div>
      </div>
      {/* 第四部分 */}
      <div className="relative">
        <img src={img_3} alt="Hero background" className="w-full h-auto" />
        <div className="left-[30%] top-[8%] absolute w-[40%]">
          <div className="flex flex-col items-left">
            <span className="text-[#ffffff] text-[1.8vw] text-center">项元汴评语量化等级分类可视化</span>
            <span className="text-[#ffffff] text-[1.2vw]  text-center">极高(33件)、高(29件)、中等(21件)三类评价量化等级</span>
            <span className="text-[#ffffff] text-[0.8vw]  text-center leading-[1.5vw]" style={{ letterSpacing: '0.1em' }}>Visualization of Xiang Yuanbian’s Ratings Classification:</span>
            <span className="text-[#ffffff] text-[0.8vw]  text-center leading-[1.5vw]" style={{ letterSpacing: '0.1em' }}>Quantified into three rating levels: Extremely High (33 pieces) High (29 pieces) Medium (21 pieces)</span>
          </div>
        </div>
        <div className="left-[10%] top-[18%] absolute w-[80%] h-[85%]">
          <iframe
            src='https://flo.uri.sh/visualisation/23738636/embed'
            title='Interactive or visual content'
            className='flourish-embed-iframe'
            style={{ width: '100%', height: '100%' }}
            sandbox='allow-same-origin allow-forms allow-scripts allow-downloads allow-popups allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation'>
          </iframe>
        </div>
      </div>
      {/* 第五部分 */}
      <div className="relative" ref={parentRef}>
        <img src={img_4} alt="Hero background" className="w-full h-auto" />
        <div className="right-[5%] top-[10%] absolute w-[35%]">
          <div className="flex flex-col items-left">
            <span className="text-[#ffffff] text-[1.4vw] text-right leading-[1.5vw]" style={{ letterSpacing: '0.1em' }}>按照瓷器编号将评价、纹饰类别、功能用途相关联</span>
            <span className="text-[#ffffff] text-[1vw]  text-right leading-[1.5vw]" style={{ letterSpacing: '0.1em' }}>Correlate evaluation, decoration category, and functional use according to porcelain numbers</span>
          </div>
        </div>
        <div className="right-[5%] top-[22%] absolute w-[18%]">
          <div className="flex flex-col items-left">
            <span className="text-[#ffffff] text-[0.7vw] text-right leading-[1.3vw]">接下来，探讨项元汴个人主观鉴藏偏好与瓷器多维度特征的深层关联。点状折线可视化图表展现了项元汴评价与瓷器纹饰、功能之间的关系。将83件瓷器的纹饰类型分为9类，您可以点击查看每个纹饰类别中瓷器的详细信息。</span>
            <span className="text-[#ffffff] text-[0.7vw] mt-[1vw] text-right leading-[1.3vw]">Next, we explore the deeper connections between Xiang Yuanbian’s subjective collecting preferences and the multi-dimensional characteristics of porcelain. The scatter-line visualization illustrates the relationship between Xiang Yuanbian’s evaluations and the decorative motifs and functions of the porcelains. The decorative patterns of the 83 porcelain items have been categorized into nine types. You may click to view detailed information about the porcelains within each decorative category.</span>
          </div>
        </div>
        <div className="left-[5%] top-[20%] absolute w-[75%] h-[70%]">
          <iframe
            src='https://flo.uri.sh/visualisation/23738659/embed'
            title='Interactive or visual content'
            className='flourish-embed-iframe'
            style={{ width: '100%', height: '100%' }}
            sandbox='allow-same-origin allow-forms allow-scripts allow-downloads allow-popups allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation'>
          </iframe>
        </div>
        <img src={img_4_5}
          className={`top-[0%] w-[40%] h-auto absolute ${isParentInView ? 'slide-in-left' : 'left-[-100]'}`} />
        <img src={img_4_6}
          className={`bottom-[0%] right-0 w-[45%] h-auto absolute ${isParentInView ? 'slide-in-right' : 'right-[-100]'}`} />
      </div>
      {/* 第六部分 */}
      <div className="relative">
        <img src={img_4} alt="Hero background" className="w-full h-auto" />
        <div className="left-[10%] top-[4%] absolute w-[35%]">
          <div className="flex flex-col items-left">
            <span className="text-[#ffffff] text-[1.8vw] text-center">评价-窑口</span>
            <span className="text-[#ffffff] text-[1.2vw]  text-center">Evaluation of Kiln Origins</span>
          </div>
        </div>
        <div className="right-[8%] top-[4%] absolute w-[35%]">
          <div className="flex flex-col items-left">
            <span className="text-[#ffffff] text-[1.8vw] text-center">评价-纹饰</span>
            <span className="text-[#ffffff] text-[1.2vw]  text-center">Evaluation of Ornamental Design</span>
          </div>
        </div>
        <div className="left-[13%] bottom-[10%] absolute w-[33%]">
          <div className="flex flex-col items-left">
            <span className="text-[#ffffff] text-[0.8vw] text-center">桑基图可视化图表展现了项元汴的评价与瓷器窑型之间的相关性，为他对特定窑型的主观偏好提供了见解。</span>
            <span className="text-[#ffffff] text-[0.8vw] mt-[1vw] text-center">The Sankey diagram illustrates the correlations between Xiang Yuanbian’s appraisals and the kiln attributions of the porcelains, offering insights into his subjective preference for specific kiln types.</span>
          </div>
        </div>
        <div className="right-[8%] bottom-[10%] absolute w-[35%]">
          <div className="flex flex-col items-left">
            <span className="text-[#ffffff] text-[0.8vw] text-center">和弦图可视化展现了项元汴个人评价与瓷器纹饰之间的关联，通过项元汴评语探究他对于瓷器纹饰类型的偏好。</span>
            <span className="text-[#ffffff] text-[0.8vw] mt-[1vw] text-center">The chord diagram illustrates the interconnections between Xiang Yuanbian’s appraisals and the decorative patterns of porcelains, providing insights into his aesthetic inclinations toward particular ornamental motifs.
            </span>
          </div>
        </div>
        <div className="left-[3%] top-[14%] absolute w-[50%] h-[60%]">
          <iframe
            src='https://flo.uri.sh/visualisation/23738682/embed'
            title='Interactive or visual content'
            className='flourish-embed-iframe'
            style={{ width: '100%', height: '100%' }}
            sandbox='allow-same-origin allow-forms allow-scripts allow-downloads allow-popups allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation'>
          </iframe>
        </div>
        <div className="right-[0%] top-[14%] absolute w-[50%] h-[60%]">
          <iframe
            src='https://flo.uri.sh/visualisation/23738694/embed'
            title='Interactive or visual content'
            className='flourish-embed-iframe'
            style={{ width: '100%', height: '100%' }}
            sandbox='allow-same-origin allow-forms allow-scripts allow-downloads allow-popups allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation'>
          </iframe>
        </div>
      </div>
      {/* 第七部分 */}
      <div className="relative" ref={parentRef1}>
        <img src={img_4} alt="Hero background" className="w-full h-auto" />
        <div className="left-[30%] top-[8%] absolute w-[40%]">
          <div className="flex flex-col items-left">
            <span className="text-[#ffffff] text-[1.8vw] text-center" style={{ letterSpacing: '0.1em' }}>项元汴评语喜好程度—极高（30件）</span>
            <span className="text-[#ffffff] text-[1.3vw]  text-center" style={{ letterSpacing: '0.1em' }}>Classification of Xiang Yuan Bian's Commentary Preferences</span>
          </div>
        </div>
        <div className="left-[15%]  top-[22%] absolute w-[70%]">
          <div className="flex flex-col items-left">
            <span className="text-[#ffffff] text-[0.8vw] text-center leading-[1.5vw]">欢迎踏入鉴藏家的精神宇宙。这里，项元汴42,187字的亲笔评注不再是尘封的墨迹，而是解码明代审美基因的密钥。如果说“探微”篇揭示了瓷器的客观基因，那么“品韵”篇则将镜头对准项元汴的主观审美宇宙。作为明代最具影响力的鉴藏家，他以“精鉴藏，通画理”的哲学，将艺术鉴赏升华为文化修行。您可以点击每个瓷器的项元汴评价图谱放大查看。</span>
            <span className="text-[#ffffff] text-[0.8vw] text-center mt-[1.5vw] leading-[1.5vw]">Based on the sentiment analysis of Xiang Yuanbian’s commentaries, his evaluations have been quantified into three hierarchical levels: Extremely High (33 items), High (29 items), and Moderate (21 items). The sentiment-based visualization categorizes the keywords from his appraisals accordingly. Below is a display of 30 porcelain items classified under the “Extremely High” preference level according to Xiang Yuanbian’s evaluative criteria. You may click on each item to view its detailed information and original commentary, offering insight into the porcelains that Xiang Yuanbian valued most highly.</span>
          </div>
        </div>
        <img src={img_4_7}
          className={`top-[8%] right-0 w-[50%] h-auto absolute ${isParentInView1 ? 'slide-in-right' : 'right-[-100]'}`} />
      </div>
      {/* 第八部分 */}
      <div className="relative">
        <img src={img_4} alt="Hero background" className="w-full h-auto" />
        <div className='absolute top-[-50%] left-0 w-full h-[200%] z-[88]'>
          {selectedItem && (
            <OPPop
              appId={1}
              popId={selectedItem.id}
              onClose={() => setSelectedItem(null)}
            />
          )}
          <img src={img_4_8} className="top-[4%] left-[26%] w-[47%] h-auto absolute" />
          <img src={h_1} className="top-[0.5%] left-[19%] w-[35%] h-auto absolute high-body" onClick={() => setSelectedItem({ id: 1 })} />
          <img src={h_2} className="top-[7%] left-[54%] w-[16%] h-auto absolute high-body" onClick={() => setSelectedItem({ id: 2 })} />
          <img src={h_3} className="top-[27%] left-[66%] w-[30%] h-auto absolute high-body" onClick={() => setSelectedItem({ id: 19 })} />
          <img src={h_4} className="top-[32.5%] left-[41.5%] w-[13%] h-auto absolute high-body" onClick={() => setSelectedItem({ id: 41 })} />
          <img src={h_5} className="top-[80%] left-[45%] w-[18%] h-auto absolute high-body" onClick={() => setSelectedItem({ id: 73 })} />
          <img src={h_6} className="top-[70%] left-[62%] w-[13%] h-auto absolute high-body" onClick={() => setSelectedItem({ id: 77 })} />
          <img src={h_7} className="top-[77.5%] left-[75%] w-[15%] h-auto absolute high-body" onClick={() => setSelectedItem({ id: 72 })} />
          <img src={h_8} className="top-[78%] left-[14%] w-[30%] h-auto absolute high-body" onClick={() => setSelectedItem({ id: 61 })} />
          <img src={h_9} className="top-[67.5%] left-[12%] w-[26%] h-auto absolute high-body" onClick={() => setSelectedItem({ id: 58 })} />
          <img src={h_10} className="top-[60.5%] left-[3.5%] w-[22%] h-auto absolute high-body" onClick={() => setSelectedItem({ id: 55 })} />
          <img src={h_11} className="top-[56%] left-[67%] w-[16%] h-auto absolute high-body" onClick={() => setSelectedItem({ id: 64 })} />
          <img src={h_12} className="top-[38.5%] left-[50%] w-[42%] h-auto absolute high-body" onClick={() => setSelectedItem({ id: 44 })} />
          <img src={h_13} className="top-[43.5%] left-[25%] w-[25%] h-auto absolute high-body" onClick={() => setSelectedItem({ id: 47 })} />
          <img src={h_14} className="top-[16.5%] left-[67%] w-[16%] h-auto absolute high-body" onClick={() => setSelectedItem({ id: 18 })} />
          <img src={h_15} className="top-[23.5%] left-[82%] w-[13%] h-auto absolute high-body" onClick={() => setSelectedItem({ id: 22 })} />
          <img src={h_16} className="top-[39%] left-[70%] w-[22%] h-auto absolute high-body" onClick={() => setSelectedItem({ id: 43 })} />
          <img src={h_17} className="top-[22%] left-[45%] w-[21%] h-auto absolute high-body" onClick={() => setSelectedItem({ id: 6 })} />
          <img src={h_18} className="top-[12%] left-[35%] w-[20%] h-auto absolute high-body" onClick={() => setSelectedItem({ id: 3 })} />
          <img src={h_19} className="top-[17.5%] left-[14%] w-[24%] h-auto absolute high-body" onClick={() => setSelectedItem({ id: 10 })} />
          <img src={h_20} className="top-[26.5%] left-[31%] w-[16%] h-auto absolute high-body" onClick={() => setSelectedItem({ id: 14 })} />
          <img src={h_26} className="top-[31.5%] left-[13.5%] w-[20%] h-auto absolute high-body" onClick={() => setSelectedItem({ id: 38 })} />
          <img src={h_27} className="top-[25.5%] left-[4.5%] w-[18%] h-auto absolute high-body" onClick={() => setSelectedItem({ id: 35 })} />
          <img src={h_21} className="top-[40.5%] left-[3.5%] w-[23%] h-auto absolute high-body" onClick={() => setSelectedItem({ id: 40 })} />
          <img src={h_22} className="top-[56.5%] left-[33%] w-[17%] h-auto absolute high-body" onClick={() => setSelectedItem({ id: 56 })} />
          <img src={h_23} className="top-[51%] left-[18%] w-[15%] h-auto absolute high-body" onClick={() => setSelectedItem({ id: 50 })} />
          <img src={h_24} className="top-[53.5%] left-[52%] w-[15%] h-auto absolute high-body" onClick={() => setSelectedItem({ id: 51 })} />
          <img src={h_25} className="top-[54.5%] left-[81.5%] w-[13%] h-auto absolute high-body" onClick={() => setSelectedItem({ id: 53 })} />
          <img src={h_28} className="top-[67%] left-[83%] w-[14%] h-auto absolute high-body" onClick={() => setSelectedItem({ id: 63 })} />
          <img src={h_29} className="top-[68.5%] left-[42%] w-[23%] h-auto absolute high-body" onClick={() => setSelectedItem({ id: 59 })} />
        </div>

      </div>
      {/* 第九部分 */}
      <div className="relative" ref={parentRef2}>
        <img src={img_4} alt="Hero background" className="w-full h-auto" />
        <img src={img_4_18}
          className={`top-[-85%] w-[100%] right-[0%] h-auto absolute ${isParentInView2 ? 'slide-in-right' : '-[-100%]'}`} />
        <img src={img_4_9}
          className={`top-[-15%] w-[100%] left-[0%] h-auto absolute ${isParentInView2 ? 'slide-in-left' : 'left-[-100%]'}`} />
        <div className="left-[20%] bottom-[30%] absolute w-[60%]">
          <div className="flex flex-col items-left">
            <span className="text-[#ffffff] text-[1.5vw] text-center" style={{ letterSpacing: '0.1em' }}>主客观对话</span>
            <span className="text-[#ffffff] text-[1.2vw]  text-center" style={{ letterSpacing: '0.1em' }}>—项元汴主观偏好（主观）与独特性量化数据（客观）对比与关联</span>
            <span className="text-[#ffffff] text-[1.2vw]  text-center" style={{ letterSpacing: '0.1em' }}>Dialogue Between Subjective and Objective</span>
            <span className="text-[#ffffff] text-[1vw]  text-center" style={{ letterSpacing: '0.1em' }}>Comparing and Connecting Xiang Yuanbian’s Subjective Preferences with Quantified Uniqueness Data</span>
          </div>
        </div>
        <div className="left-[15%]  bottom-[5%] absolute w-[70%]">
          <div className="flex flex-col items-left">
            <span className="text-[#ffffff] text-[0.8vw] text-center leading-[1.3vw]">最终，构建主客观对话，让独特性量化数据与项元汴主观偏好在关联网络中碰撞，验证“以器载道”的实践逻辑。下面展示了项元汴评价中“极高”喜好等级中的30件瓷器（图左）和瓷器独特性量化中高独特性（独特性分值≥0.85）的10件瓷器（图右）的关联和对比。在高独特性排名前十名中，我们发现7件器物，既因其工艺稀有性（客观）登顶，又因契合项元汴“以器载道”的哲学（主观）而被赋予永恒价值，在项元汴评价量化等级分类中位居“极高”喜好队列。在这里，数据与评语交织，主观与客观共振，重构出一位博物君子的审美基因图谱。</span>
            <span className="text-[#ffffff] text-[0.8vw] text-center mt-[1vw]">Finally, a dialogue between the subjective and objective is constructed, allowing quantified data on porcelain uniqueness to interact with Xiang Yuanbian’s personal aesthetic preferences within a relational network. This aims to validate the practical logic of "using objects to embody the Dao" (yi qi zai dao).</span>
            <span className="text-[#ffffff] text-[0.8vw] text-center">Below, we present a comparison: on the left are the 30 porcelains rated as "Extremely High" in Xiang Yuanbian’s evaluation system, and on the right are the 10 porcelains ranked highest in quantified uniqueness (uniqueness score ≥ 0.85). </span>
            <span className="text-[#ffffff] text-[0.8vw] text-center">Here, data and commentary converge, subjectivity and objectivity resonate, reconstructing the aesthetic DNA profile of a learned gentleman-collector.</span>
          </div>
        </div>
      </div>
      {/* 第十部分 */}
      <div className="relative z-[9]">
        <img src={img_4} alt="Hero background" className="w-full h-auto" />
        <div className={`absolute left-[6%] ${isLeftActive ? 'ten-ico-active-red' : 'ten-ico-normal'}`}></div>
        <div className={`absolute right-[6%] ${!isLeftActive ? 'ten-ico-active' : 'ten-ico-normal'}`}></div>
        <div className="left-[6%] top-[13%] absolute w-[100%]">
          <div className="flex flex-col items-left">
            <span className={`text-[#ffffff] text-left duration-500 ${isLeftActive ? 'text-[2vw]' : 'text-[1.3vw]'}`} >项元汴评语喜好程度—极高（30件）</span>
            <span className={`text-[#ffffff] text-left duration-500 ${isLeftActive ? 'text-[1.5vw]' : 'text-[1vw]'}`}>Classification of Xiang Yuan Bian's Commentary Preferences</span>
          </div>
        </div>
        <div className="right-[6%] top-[13%] absolute w-[100%]">
          <div className="flex flex-col items-left">
            <span className={`text-[#ffffff] text-right duration-500 ${!isLeftActive ? 'text-[2vw]' : 'text-[1.3vw]'}`}>高独特性瓷器-前10名</span>
            <span className={`text-[#ffffff] text-right duration-500 ${!isLeftActive ? 'text-[1.5vw]' : 'text-[1vw]'}`}>Top 10 Porcelains with High Uniqueness</span>
          </div>
        </div>
        <div className='absolute w-full h-[170%] top-[25%]'>
          <div className={`absolute cursor-pointer left-0 top-0 ${isLeftActive ? 'ten-active' : 'ten-normal w-[45%] h-[40%]'}`}
            onClick={() => handleSetTenActive()}>
            <img src={img_4_9}
              className={`top-[65%] w-[90%] left-[0%] h-auto absolute ${isParentInView2 ? 'slide-in-left' : 'left-[-100%]'}`} />
            <img src={img_4_16} className="top-[0%] w-[80%] left-[10%] h-auto absolute" />
          </div>
          <div className={`absolute cursor-pointer right-0 top-0 ${!isLeftActive ? 'ten-active' : 'ten-normal w-[30%] h-[40%]'}`}
            ref={parentRef3}
            onClick={() => handleSetTenActive()}>
            <img src={img_4_10}
              className={`top-[6%] w-[45%] right-[-9%] h-auto absolute ${isParentInView3 ? 'slide-in-right' : 'right-[-100%]'}`} />
            <img src={img_4_8}
              className={`top-[42%] w-[25%] right-[2%] h-auto absolute ${isParentInView3 ? 'slide-in-right' : 'right-[-100%]'}`} />
            <img src={img_4_11}
              className={`top-[28%] w-[50%] right-[0%] h-auto absolute duration-3000 ${isParentInView3 ? 'opacity-100' : 'opacity-0'}`} />
            <img src={img_4_13}
              className={`top-[65%] w-[100%] right-[0%] h-auto absolute ${isParentInView3 ? 'slide-in-right' : 'right-[-100%]'}`} />
            <img src={img_4_17}
              className="top-[0%] w-[90%] right-[0%] h-auto absolute" />
          </div>
        </div>

      </div>
      {/* 第十一部分 */}
      <div className="relative">
        <img src={img_4} alt="Hero background" className="w-full h-auto" />
      </div>
      {/* 第十二部分 */}
      <div className="relative">
        <img src={img_4} alt="Hero background" className="w-full h-auto" />
        <div className='left-0 top-0 absolute w-full h-auto'>
          <video
            src={video_6}
            className="w-full h-auto"  // 铺满容器宽度，高度自适应
            autoPlay                  // 自动播放（注意：部分浏览器需要配合 muted）
            loop                      // 循环播放
            muted                     // 静音（避免自动播放被浏览器阻止）
            playsInline               // iOS 设备内联播放（非全屏）
            controls={false}          // 隐藏控制条（根据需求可改为 true 显示）
          />
        </div>
      </div>
      {/* 第十三部分 */}
      <div className="relative">
        <img src={img_4} alt="Hero background" className="w-full h-auto" />
        <div className="left-[5%] top-[10%] absolute w-[35%]">
          <div className="flex flex-col items-left">
            <span className="text-[#ffffff] text-[1.2vw] text-left">项元汴评语喜好程度—极高（30件）</span>
            <span className="text-[#ffffff] text-[1vw]  text-left">Classification of Xiang Yuan Bian's Commentary Preferences</span>
          </div>
        </div>
        <div className="right-[5%] top-[10%] absolute w-[35%]">
          <div className="flex flex-col items-left">
            <span className="text-[#ffffff] text-[1.2vw] text-right">高独特性瓷器-前10名</span>
            <span className="text-[#ffffff] text-[1vw]  text-right">Top 10 Porcelains with High Uniqueness</span>
          </div>
        </div>
        <div className="left-[44.5%] top-[25%] absolute w-[18%]">
          <div className="flex flex-col items-left">
            <span className="text-[#ffffff] text-[0.8vw] text-center">构建主客观对话，让独特性量化数据与项元汴主观偏好在关联网络中碰撞，验证“以器载道”的实践逻辑。在高独特性排名前十名中，我们发现明成窑五彩鸡缸杯(NO.1)、明成窑五彩草虫小杯(NO.2)等7件器物，既因其工艺稀有性(客观)登顶，又因契合项元汴'以器载道’的哲学(主观)而被赋予永恒价值，在项元汴评价量化等级分类中位居“极高”喜好队列。</span>
            <span className="text-[#ffffff] text-[0.8vw] mt-[1vw] text-center">Fostering a dialogue between objectivity and subjectivity, we allow quantitative data on uniqueness to collide with Xiang Yuanbian's subjective preferences within a relational network, thereby validating the practical logic of "vessels as vehicles of Tao." Among the top ten artifacts ranked highest for uniqueness, we identified seven pieces—such as the Ming Chenghua Wucai Chicken-Hen Cup (No. 1) and the Ming Chenghua Wucai Insect-Design Small Cup (No. 2)—that not only ascended to the pinnacle due to their objective rarity in craftsmanship, but were also endowed with timeless value for aligning with Xiang Yuanbian's philosophy of "vessels as vehicles of Tao." Consequently, these artifacts reside within the "highest preference tier" of Xiang Yuanbian's quantified evaluation system.</span>
          </div>
        </div>
        <img src={img_4_14} className="top-[20%] left-[5%] w-[35%] h-auto absolute" />
        <img src={img_4_15} className="top-[20%] right-[0%] w-[30%] h-auto absolute" />
      </div>
      {/* 第十四部分 */}
      <div className="relative">
        <img src={img_4} alt="Hero background" className="w-full h-auto" />
        <div className="left-[40%] top-[-10%] absolute w-[20%]">
          <div className="flex flex-col items-left">
            <span className="text-[#ffffff] text-[2vw] text-center">总结</span>
            <span className="text-[#ffffff] text-[1.5vw]  text-center">Conclusion</span>
          </div>
        </div>
        <div className='absolute ending-info'>
          <div className="left-[5%] top-[6%] absolute w-[90%]">
            <div className="flex flex-col items-left">
              <span className="text-[#ffffff] text-[1.2vw] text-center leading-[1.5vw]" style={{ letterSpacing: '0.1em' }}>「千面天籁：数据重构的鉴藏史诗」</span>
              <span className="text-[#ffffff] text-[0.8vw]  text-center leading-[1.5vw]" style={{ letterSpacing: '0.1em' }}>这场横跨五百年的鉴藏之旅，让我们重新认识了项元汴的收藏世界：</span>
              <span className="text-[#ffffff] text-[0.8vw]  text-center leading-[1.5vw]" style={{ letterSpacing: '0.1em' }}>在溯源篇，您通过家族关系和历史场景，亲历了明代商人如何用资本重塑文化话语权；鉴析篇用动态可视化数据图表，直观呈现了83件瓷器在工艺、器型、釉色、纹饰、时空分布上的客观规律；探微篇首创的量化模型，首次将“瓷器独特性”转化为可测量的数据——从形状曲线到釉色参数，从纹饰工艺到历史维度，每件藏品都获得了自己的独特性数字指纹；而品韵篇揭示的项元汴的审美偏好图谱证明，项元汴的收藏选择绝非偶然，而是暗含“以器载道”的完整哲学体系。</span>
              <span className="text-[#ffffff] text-[0.8vw]  text-center leading-[1.5vw]" style={{ letterSpacing: '0.1em' }}>作为首个系统性研究《历代名瓷图谱》的数字项目，我们不仅重建了天籁阁的收藏宇宙，更验证了跨学科研究的可能性，我们终于理解《历代名瓷图谱》的真正野心——它既是晚明物质文化的切片样本，更是留给数字时代的预言书：所有文明的精魂，终将在新的介质中重生。</span>
              <span className="text-[#ffffff] text-[0.8vw]  text-center mt-[1.5vw] leading-[1.5vw]" style={{ letterSpacing: '0.1em' }}>此刻，83组陶瓷基因已注入云端，这83组穿越时空的数据，既是明代物质文明的数字档案，也是未来探索的起点。</span>
              <span className="text-[#ffffff] text-[0.8vw]  text-center leading-[1.5vw]" style={{ letterSpacing: '0.1em' }}>期待与下一个五百年的鉴藏者相遇。</span>

              <span className="text-[#ffffff] text-[1.2vw]  text-center mt-[2vw] leading-[1.3vw]" style={{ letterSpacing: '0.1em' }}>A Thousand Faces of Heavenly Music: An Epic of Data Reconstruction</span>
              <span className="text-[#ffffff] text-[0.8vw]  text-center leading-[1.3vw]" style={{ letterSpacing: '0.1em' }}>This journey across 500 years of collecting allows us to reacquaint ourselves with Xiang Yuanbian's world of collecting: </span>
              <span className="text-[#ffffff] text-[0.8vw]  text-center leading-[1.3vw]" style={{ letterSpacing: '0.1em' }}>In the chapter of Traceability, you experienced how Ming Dynasty merchants reshaped the right of cultural discourse with capital through family relationships and historical scenarios; in the chapter of Appraisal, the dynamic visualisation of data charts and diagrams intuitively presented the objective patterns of 83 porcelain wares in terms of craftsmanship, shape, glaze, decoration, and spatial and temporal distribution; in the chapter of Microcosmology, the first quantitative model transformed the ’uniqueness of porcelain" into measurable data - from shape curves to glaze parameters, from decoration techniques to historical dimensions. The quantitative model pioneered in the chapter of micro-exploration, for the first time, the ‘uniqueness of porcelain’ is transformed into measurable data - from the shape curve to the glaze parameters, from the decorative process to the historical dimension, each piece of collectibles has gained its own uniqueness of the digital fingerprints; while the chapter of PinYun The aesthetic preference map of Xiang Yuanbian revealed in the chapter of PinYun proves that Xiang Yuanbian's choice of collection is not accidental, but implies a complete philosophical system of ‘carrying the way with wares’.</span>
              <span className="text-[#ffffff] text-[0.8vw]  text-center leading-[1.3vw]" style={{ letterSpacing: '0.1em' }}>As the first digital project to systematically study The Atlas of Famous Porcelains of All Ages, we have not only reconstructed the collection universe of Celestial Pavilion, but also verified the possibilities of interdisciplinary research, and we finally understand the real ambition of The Atlas of Famous Porcelains of All Ages - it is not only a sample of slices of the material culture of the Late Ming Dynasty, but also the prophecy of the digital era: the essence of all civilisations will finally be discovered in the new era. The essence of all civilisations will eventually be reborn in a new medium.</span>
              <span className="text-[#ffffff] text-[0.8vw]  text-center leading-[1.3vw]" style={{ letterSpacing: '0.1em' }}>At this moment, 83 sets of ceramic genes have been injected into the cloud, and these 83 sets of time-travelling data are not only the digital archives of the material civilisation of the Ming Dynasty, but also the starting point for future exploration.</span>
              <span className="text-[#ffffff] text-[0.8vw]  text-center leading-[1.3vw]" style={{ letterSpacing: '0.1em' }}>Looking forward to meeting with the next five hundred years of connoisseurs.</span>
            </div>
          </div>
        </div>
      </div>
      {/* 第十五部分 */}
      <div className="relative">
        <img src={img_4_19} alt="Hero background" className="w-full h-auto" />
      </div>
    </div>
  )
}
